module.exports = __webpack_public_path__ + "img/new-title-img.2c1cf10f.png";